import { useEffect } from "react";
import { Col, Row } from "reactstrap";
import { useUser } from "../../../hooks/useUser";
import ServiceHistory from "../../molecules/ServiceHistory";
import { UserDetails } from "../../molecules/UserDetails";

type Props = {
  id: string;
};

function UserByIdContainer({ id }: Props) {
  const { error, user, getUserById } = useUser();

  useEffect(() => {
    getUserById(id);
  }, [id]);

  if (!user || error)
    return (
      <Row>
        <Col className="d-flex justify-content-center">
          {error ? error : "User Id Not Found"}
        </Col>
      </Row>
    );
  return (
    <Col>
      <Row>
        <UserDetails user={user} />
      </Row>
      <Row>
        <ServiceHistory id={id} />
      </Row>
    </Col>
  );
}

export default UserByIdContainer;
